import { render, staticRenderFns } from "./gisDict.vue?vue&type=template&id=baa127ba&scoped=true"
import script from "./gisDict.vue?vue&type=script&lang=js"
export * from "./gisDict.vue?vue&type=script&lang=js"
import style0 from "./gisDict.vue?vue&type=style&index=0&id=baa127ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa127ba",
  null
  
)

export default component.exports